module.exports = __webpack_public_path__ + "static/media/babilou.b8fd3898.svg";